import { render, staticRenderFns } from "./UpdateDeliveryAddressModal.vue?vue&type=template&id=2a3e85cb&"
import script from "./UpdateDeliveryAddressModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateDeliveryAddressModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateDeliveryAddressModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports